import { Divider, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { Create, SimpleForm, TextInput, SelectInput, required, DateInput, AutocompleteInput, useRedirect, useNotify, RadioButtonGroupInput, FileInput, FileField } from "react-admin";
import { cleanRangeChoices, getNameAndCompanyNamewithAddress } from "../common";
import { useLocation, useParams, } from "react-router-dom";

const CleanHistoryCreate = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const redirect = useRedirect();
  const notify = useNotify();
  const [customers,setCustomers]=useState([]);
  const [customerId,setCustomerId]=useState(searchParams.get("customer"));
  const [invoiceHistory,setInvoiceHistory] =useState([]);
  const [isNew, setisNew] = useState(-1); 
  const [isPay,setIsPay] = useState(0);
  const [pumpingPay, setPumpingPay] = useState(0);
  const [pumpingAmount, setPumpingAmount] = useState(0);
  const [invoiceAmount, setInvoiceAmount] = useState(0);
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_DIR}/customers/clean`, {
          method: "GET",
          headers: new Headers({ "Content-Type": "application/json" }),
          mode: "cors",
          credentials: "include",
        });
        if (!response.ok) {
          throw new Error("Failed to fetch user info");
        }
        const { data } = await response.json();
        setCustomers(data);
      } catch (error) {
        console.error("ユーザー情報の取得に失敗しました:", error);
      } finally {
        // setLoading(false);
      }
    };
    fetchUser();
  }, []);

  useEffect(()=>{
    const fetchInvoice = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_DIR}/invoiceHistory/customer/${customerId}`, {
          method: "GET",
          headers: new Headers({ "Content-Type": "application/json" }),
          mode: "cors",
          credentials: "include",
        });
        if (!response.ok) {
          throw new Error("Failed to fetch user info");
        }
        const { data } = await response.json();
        console.log(data);
        setInvoiceHistory(data);
      } catch (error) {
        console.error("ユーザー情報の取得に失敗しました:", error);
      } finally {
        // setLoading(false);
      }
    };

    if(customerId){
      fetchInvoice();
    }
  },[customerId])

  useEffect(()=>{
    if(customers.length > 0 && customerId){
      const payValue = customers.find(req => req.id === customerId)?.exPumpingPay || 0;
      const amountValue = customers.find(req => req.id === customerId)?.exPumpingAmount || 0;
      setPumpingPay(payValue);
      setPumpingAmount(amountValue);
      setInvoiceAmount(payValue * amountValue);
      console.log("Customer data loaded:", payValue, amountValue);
    }
  },[customers])

  // pumpingPayやpumpingAmountが変更されたときにinvoiceAmountを自動更新
  useEffect(() => {
    setInvoiceAmount(pumpingPay * pumpingAmount);
  }, [pumpingPay, pumpingAmount]);


  return (
    <>
    {customers &&
      <Create 
        mutationMode="pessimistic"
        transform={(data) => {
          console.log('Create transform - Original data:', data);
          // 計算された値を強制的に追加
          const transformedData = {
            ...data,
            pumpingPay: pumpingPay || 0,
            pumpingAmount: pumpingAmount || 0, 
            invoiceAmount: invoiceAmount || 0
          };
          console.log('Create transform - Transformed data:', transformedData);
          return transformedData;
        }}
        mutationOptions={{ 
          onSuccess: () => {
            notify('作成が完了しました', { type: 'success' }); 
            // redirect('list', 'cleanHistory');
            window.history.back();
          },
          onError: (error) => {
            console.error('Save error:', error);
          }
        }}
      >
      <SimpleForm
        onKeyDown={e => {
          if (e.key === 'Enter') {
              e.preventDefault();
          }
        }}
      >
        <AutocompleteInput
          source="customerId"
          label="顧客名"
          choices={customers.map(req => ({
            id: req.id, 
            name: `${getNameAndCompanyNamewithAddress(req)}`
          }))}
          onChange={(e) => setCustomerId(e)}
          validate={required()}
          defaultValue={customerId}
          allowEmpty
          freeSolo  
        />
        <div style={{display:"flex", justifyContent:"space-between",width:"100%"}}>
          <DateInput source="cleaningDate" label="清掃日" style={{marginRight:"10px"}} inputProps={{ max: '9999-12-31' }}/>
          <TextInput source="pumpingWeigh" label="汲取実量(㎥)" type="number" style={{marginLeft:"10px",marginRight:"10px"}}/>
          <SelectInput 
            source="cleanRange"
            label="清掃範囲"
            choices={cleanRangeChoices}
            style={{marginLeft:"10px"}}
          />
        </div>         
          <TextInput source="content" label="清掃内容" multiline rows={5}/>
          <div style={{display:"flex", justifyContent:"space-between",width:"100%"}}>
            <SelectInput source="staffName" label="担当者名1" style={{marginRight:"10px"}} choices={[
                { id: "平山", name: "平山" },
                { id: "小室", name: "小室" },
              ]}/>
            <SelectInput source="staffName2" label="担当者名2" style={{marginLeft:"10px"}}choices={[
                { id: "平山", name: "平山" },
                { id: "小室", name: "小室" },
              ]}/>
          </div>
          <div style={{display:"flex", justifyContent:"space-between",width:"100%"}}>
            <TextInput 
              source="pumpingPay" 
              label="金額" 
              style={{marginRight:"10px"}} 
              disabled={!customerId} 
              defaultValue={customers.find(req => req.id === customerId)?.exPumpingPay}
              onChange={(e) => setPumpingPay(Number(e.target.value) || 0)}
            />
            <TextInput 
              source="pumpingAmount" 
              label="汲取予定量(㎥)" 
              type="number" 
              style={{marginLeft:"10px"}} 
              disabled={!customerId} 
              defaultValue={customers.find(req => req.id === customerId)?.exPumpingAmount}
              onChange={(e) => setPumpingAmount(Number(e.target.value) || 0)}
            />
          </div>
          {/* <SelectInput 
            source="isNew"
            label="請求情報"
            choices={[
              { id: -1, name: "後から追加" },
              { id: 1, name: "新規追加" },
              { id: 0, name: "請求履歴から選択" }
            ]}
            validate={required()}
            defaultValue={-1}
            onChange={(e) => setisNew(e.target.value)}
          /> */}
           {/* {isNew === -1 ? (
            <></>
           ) : ( */}
            <>
            <Divider sx={{ my: 2 }} /> {/* セクション区切り */}
            <Typography variant="h6">請求情報</Typography>
            {/* {isNew === 1 ? ( */}
              {/* <> */}
                <div style={{display:"flex", justifyContent:"space-between",width:"100%"}}>
                  <DateInput source="invoiceDate" label="請求日" style={{marginRight:"10px"}} inputProps={{ max: '9999-12-31' }}/>
                  <TextInput 
                    source="invoiceAmount" 
                    label="請求金額(税抜き)" 
                    disabled={true}
                    style={{marginLeft:"10px",marginRight:"10px"}}
                    format={(value) => {
                      return invoiceAmount.toLocaleString();
                    }}
                    onChange={(e) => setInvoiceAmount(Number(e.target.value) || 0)}
                  />
                  <SelectInput source="payMethod" label="支払い方法" choices={[
                    { id: "持参", name: "持参" },
                    { id: "振り込み", name: "振り込み" },
                    { id: "集金", name: "集金" }
                  ]} style={{marginLeft:"10px"}}/>
                </div>
                <DateInput source="reissueDate" label="再発行日" inputProps={{ max: '9999-12-31' }}/>
                <RadioButtonGroupInput
                  source="isPay"
                  label="領収"
                  choices={[
                    { id: 1, name: '領収済み' },
                    { id: 0, name: '未領収' }
                  ]}
                  defaultValue={isPay}
                  validate={required()}
                  onChange={(e) => setIsPay(Number(e.target.value))}
                />
                <DateInput source="receiptDate" label="領収日" disabled={!isPay} inputProps={{ max: '9999-12-31' }}/>
                <FileInput source="documentURL" label="請求書" accept="application/pdf, image/*">
                  <FileField source="src" title="title" />
                </FileInput>
              </>
              {/* ) : (
                 <AutocompleteInput
                source="invoiceId"
                label="請求履歴"
                choices={invoiceHistory.map(req => ({
                  id: req.invoiceId, 
                  name: `請求No.${String(req.id).padStart(5, "0")}（請求日：${(new Date(req.invoiceDate)).toLocaleDateString('ja-JP')}）`
                }))}
                disabled={!customerId}
                allowEmpty
                freeSolo  
              />
            )}
          </>
          )} */}
        </SimpleForm>
      </Create>
    }
    </>
  )

};

export default CleanHistoryCreate;
